import { useState } from "react";
import { useToast } from "../../../shared/hooks";
import { ToastContent } from "../../../shared/components";
import { FireServices } from "../../../shared/services/api/fire/FireServices";

export function useFireContract() {
    const [loading, setLoading] = useState(false);
    const toastHandler = useToast();

    const contract = async (fireId: string, onSuccess?: () => void) => {
        try {
            setLoading(true);

            const resp = await FireServices.FireContractQuotation(fireId);

            if (resp instanceof Error) throw new Error();

            toastHandler.present({
                type: "success",
                position: "top-right",
                messageOrContent: (
                    <ToastContent title="Sucesso" content="Seguro contratado com sucesso!" />
                ),
            });

            onSuccess?.();
        } catch {
            toastHandler.present({
                type: "error",
                position: "top-right",
                messageOrContent: (
                    <ToastContent title="Erro" content="Falha ao contratar o seguro." />
                ),
            });
        } finally {
            setLoading(false);
        }
    };

    return { contract, loading };
}
